import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { VISTACION_URL } from "@/constants";

export const CtaBanner = () => {
  return (
    <section
      data-testid="cta-banner-section"
      className="relative py-24 lg:py-32 bg-obsidian overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 30% 20%, #C5A059 0%, transparent 45%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl"
        >
          <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-6xl text-white tracking-tight leading-[1.1]">
            Aviation. Yachting. Commodities.{" "}
            <span className="text-gold italic">Digital Innovation.</span>
          </h2>
          <p className="mt-8 text-base sm:text-lg text-white/70 font-light leading-relaxed max-w-2xl">
            Whether you are looking to acquire a private aircraft, charter a
            flight, purchase a luxury yacht, source commodities, or explore
            blockchain-powered commerce, Aerovista Group delivers world-class
            solutions through its global network.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="/#contact"
              data-testid="cta-contact-button"
              className="group inline-flex items-center gap-3 bg-gold text-black text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-gold-light"
            >
              Contact Our Team
              <ArrowRight
                size={14}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
            <a
              href={VISTACION_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-access-vistacion-button"
              className="group inline-flex items-center gap-3 border border-white/20 text-white/80 text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-white/5 hover:text-white"
            >
              Access Vistacion
              <ArrowUpRight
                size={14}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
